import styled from 'styled-components';

export const NameCellContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const NameSkuContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

export const IconActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 8px;
  padding: 4px 0px;
`;

export const RemoveIconContainer = styled.div`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  justify-content: flex-end;
`;

export const CloseIcon = styled.img`
  &:hover {
    color: ${(props) => props.theme.colors.brand.primary};
    cursor: pointer;
  }
`;

export const BadgeContainer = styled.div`
  background-color: ${(props) => props.theme.colors.brand.primary};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
`;
